// Official Quantum Cover logo — deep forest green "Q" ring with a fresh-green leaf tail.
// Do not restyle the mark; only the wordmark colour adapts to light/dark backgrounds.

export const QMark = ({ size = 40, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="29" cy="30" r="15" fill="none" stroke="currentColor" strokeWidth="6" />
    <path d="M30 30 C 42 27, 51 35, 49 50 C 34 47, 28 40, 30 30 Z" fill="#059669" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => {
  const forest = light ? "text-white" : "text-[#0B3D2E]";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span className={`${forest} transition-colors`}>
        <QMark size={38} />
      </span>
      <span className="leading-none">
        <span className={`block font-display font-bold tracking-tight text-lg ${light ? "text-white" : "text-[#0B3D2E]"}`}>QUANTUM</span>
        <span className={`block font-display font-semibold tracking-[0.18em] text-xs -mt-0.5 ${light ? "text-emerald-400" : "text-emerald-600"}`}>COVER</span>
      </span>
    </span>
  );
};
